import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { MutationConfig } from '@/library/react-query';
import { queryClient } from '@/library/react-query';

type InputSipType = {
  customerId: string | undefined;
  SipActionType: string;
  payload: {
    pgSubscriptionId: string;
    status: string;
  };
};

export const changeSipStatus = (data: InputSipType): Promise<any> => {
  const { customerId, SipActionType, payload } = data;
  return axios.patch(
    `dg/customers/${customerId}/${SipActionType}?sipId=${payload.pgSubscriptionId}`
  );
};

type UseSipStatusType = {
  config?: MutationConfig<typeof changeSipStatus>;
};

export const UseChangeSipStatus = ({ config = {} }: UseSipStatusType = {}) => {
  return useMutation({
    onError: (_, __) => {},
    // context: any
    onSuccess: () => {
      queryClient.invalidateQueries(['sipsList']);
    },
    ...config,
    mutationFn: changeSipStatus,
    useErrorBoundary: false,
  });
};
